import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../../assets/css/customer/publicCustomerCss/service.css';

const ServicesBlock = ({ service, index }) => {
    const { icon, title, description } = service;
    const navigate = useNavigate();
    
    const checkUserLogin = () => {
        const token = localStorage.getItem('authToken') || localStorage.getItem('userToken') || localStorage.getItem('token');
        const userData = localStorage.getItem('userData');
        const sessionToken = sessionStorage.getItem('authToken');
        const isLoggedIn = token || sessionToken || userData;
        
        if (userData) {
            try {
                const user = JSON.parse(userData);
                return user.role === 'customer' || user.type === 'customer' || user.isCustomer === true;
            } catch (e) {
                return false;
            }
        }
        
        return !!isLoggedIn;
    };
    
    const getServicePath = (title) => {
        const pathMap = {
            'NORTH': '/destinations',
            'HOTELS': '/hotels',
            'FOOD': '/food-blogs',
            'EVENTS': '/eventblogs',
            'AI PLANNER': '/ai-planner',
            'TRAVEL GUIDE': '/travelguide'
        };
        return pathMap[title] || '/';
    };
    
    const handleClick = () => {
        if (title === 'AI PLANNER') {
            if (checkUserLogin()) {
                navigate('/ai-planner');
            } else {

                navigate('auth/login', { 
                    state: { 
                        returnUrl: '/ai-planner',
                        message: 'Please login to access AI Planner' 
                    } 
                });
            
            }
        } else {
            const path = getServicePath(title);
            navigate(path);
        }
    };
    
    return (
        <div 
            className={`pub-serv-service-block pub-serv-block-${index + 1}`}
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
        >
            <div className="pub-serv-service-icon">
                <i className={icon}></i>
            </div>
            <h3 className="pub-serv-service-title">{title}</h3>
            <p className="pub-serv-service-desc">{description}</p>
            <div className="pub-serv-shine"></div>
        </div>
    );
};

export default ServicesBlock;